import React from "react";
import { Select } from "@foris/avocado-suite";
import UsableLabel from "@common/components/Autocomplete/usabe-label";
import useClassroomSearch, { ClassroomOption } from "../../hooks/useClassroomSearch";

interface ClassroomSelectProps {
  label?: string;
  placeholder?: string;
  value: ClassroomOption | null;
  disabled?: boolean;
  isClearable?: boolean;
  menuPlacement?: "top" | "bottom" | "auto";
  onChange: (option: ClassroomOption | null) => void;
}

const getFormattedLabel = (option: unknown) => {
  const data = option as ClassroomOption;
  return (
    <UsableLabel
      label={`${data.code} - ${data.name} - ${data?.building?.campus?.code || ""}`}
      isUsable={data?.usable}
    />
  );
};

const ClassroomSelect = ({
  label,
  placeholder,
  value,
  disabled = false,
  isClearable = false,
  menuPlacement = "bottom",
  onChange,
}: ClassroomSelectProps) => {
  const { options, loading, onSearch } = useClassroomSearch();

  return (
    <Select
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      isLoading={loading}
      options={options}
      value={value}
      isClearable={isClearable}
      menuPlacement={menuPlacement}
      isOptionDisabled={option => !!(option as any)?.isDisabled}
      formatOptionLabel={getFormattedLabel}
      onInputChange={val => onSearch(val)}
      onChange={(opt: ClassroomOption) => onChange(opt ?? null)}
    />
  );
};

export default ClassroomSelect;
